const PolicySubStatusTypeCN = {
    'DHF': '待回访',
    'HFFAIL': '回访失败',
    'DHZ': '待回执',
    'HF': '回访成功',
};

const PolicyStatusTypeCN = {
    'CB': '已承保',
    'SS': '生效中',
    'CD': '已撤单',
    'HTB': '犹豫期退保',
    'TB': '退保',
    'ZZ': '保单终止',
    'ZD': '失效终止',
};


export const ReserveStatusType = {
    '待预约': 0,
    // '逾期未预约': 1,
    '预约失败': 2,
    '已预约': 3,
    '已取消': 4,
    '已结束': 5,
    '回访结果待更新': 6,
    '未发起预约': 100,
};


export const ReserveStatusTypeCN = {
    0: '待预约',
    1: '预约失败',
    2: '预约失败',
    3: '待保司回访',
    4: '已取消',
    5: '已结束',
    6: '回访结果待更新',
    100: '未发起预约',
};

export const ReserveStatusTypeSystem = {
    ...ReserveStatusType,
    '逾期未预约': 1,
};

const ReserveStatusTypeAll = {
    ...ReserveStatusType,
    ...ReserveStatusTypeCN,
};

const ExportTypes = {
    POLICY_ACK_INFO_MERCHANT: {
        showSettlementEffectOnly: { title: '仅展示影响结算保单' },
        policySubStatus: { title: '回执回访状态', type: PolicySubStatusTypeCN },
        policyStatus: { title: '保单状态', type: PolicyStatusTypeCN },
        policyId: { title: '保单号' },
        holderName: { title: '投保人' },
        orgName: { title: '商户名称' },
        agencyName: { title: '业务员' },
        spuName: { title: '产品名称' },
        lastTimeEnd: { title: '上次回执回访时间截止' },
        lastTimeStart: { title: '上次回执回访时间开始' },
        hesitationPeriodEndTime: { title: '犹豫期截止时间' },
        // policyIdList: { title: '保单号集合' },
        ackStatus: { title: '回访状态', type: PolicySubStatusTypeCN },
        reserveStatus: { title: '预约状态', type: ReserveStatusTypeAll },
        appointmentTimeStart: { title: '预约开始时间' },
        appointmentTimeEnd: { title: '预约结束时间' },
        insureOrgName: { title: '保险公司名称' },
        brandName: { title: '产品商名称' },
        acceptedTimeStart: { title: '承保时间开始' },
        acceptedTimeEnd: { title: '承保时间结束' },
        endGraceTimeStart: { title: '宽限期止期开始' },
        endGraceTimeEnd: { title: '宽限期止期结束' },
        renewPolicyAcceptedTimeStart: { title: '续保承保时间开始' },
        renewPolicyAcceptedTimeEnd: { title: '续保承保时间结束' },
        renewPolicyId: { title: '续保单号' },
        endedTimeStart: { title: '保单到期时间开始' },
        endedTimeEnd: { title: '保单到期时间结束' },
        companyId: { title: '机构编号' },
        groupId: { title: '所属团队' },
        insureOrgId: { title: '保险公司编号' },
    },
    // 继续率统计导出
    CONTINUE_RATE_LIST: {
        duePaymentTime: { title: '应续月份'},
        settlementTime: { title: '结算月份'},
        spuName: { title: '产品名称' },
        spuId: { title: '产品ID' },
        // brandName: { title: '产品商'},
        // supplierName: { title: '供应商'},
        orgName: { title: '商户名称'},
        agencyName: { title: '业务员'},
        cycle: { title: '继续率周期'},
        continueRate: { title: '当前继续率'},
        continueRateRange: { title: '继续率等级'},
        continueRateFee: { title: '实际续期推广费'},
    },

}

export default ExportTypes;